import React from 'react'
import { useTranslation } from 'react-i18next'
import { Paper, Typography } from '@mui/material'
import PropTypes from 'prop-types'

import { PUBLIC_URL } from '../../common/constants'

function DigitalCertificateHeader({ certificateData }) {
  const isRefactory = certificateData?.basicData?.isRefactory ?? false
  const { t } = useTranslation()
  return isRefactory ? (
    <Paper
      elevation={0}
      sx={({ palette }) => ({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        p: 2,
        backgroundColor: palette.common.black,
      })}
    >
      <img
        height={60}
        src={`${PUBLIC_URL}/assets/favicons/refactory-icon.png`}
        alt=""
      />
      <Typography variant="h1" color="primary.contrastText" sx={{ ml: 3 }}>
        {t('appTitleRefactory')}
      </Typography>
    </Paper>
  ) : (
    <Paper
      elevation={0}
      sx={({ palette }) => ({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        p: 2,
        backgroundColor: palette.common.black,
      })}
    >
      <img src={`${PUBLIC_URL}/assets/favicons/apple-icon-60x60.png`} alt="" />
      <Typography variant="h1" color="primary.contrastText" sx={{ ml: 3 }}>
        {t('appTitle')}
      </Typography>
    </Paper>
  )
}

DigitalCertificateHeader.propTypes = {
  certificateData: PropTypes.object,
}

DigitalCertificateHeader.defaultProps = {
  certificateData: null,
}

export default DigitalCertificateHeader
